export const sanitiseReg = (vrn: string) => vrn.toUpperCase().replace(/ /g, ``)
